import CoreSpacerFactory from "./Core/Spacer";
import CoreHeadingFactory from "./Core/Heading";
import CoreTableFactory from "./Core/Table";
import CoreColumnsFactory from "./Core/Columns";
import CoreColumnFactory from "./Core/Column";
import CoreGroup from "./Core/Group";
import CoreParagraphFactory from "./Core/Paragraph";
import CoreShortCodeFactory from "./Core/ShortCode";
import CoreListFactory from "./Core/List";
import CoreHtmlFactory from "./Core/Html";
import CoreQuoteFactory from "./Core/Quote";
import CoreEmbedFactory from "./Core/Embed";
import CoreImageFactory from "./Core/Image";
import CoreEmbedYoutube from "./Core/CoreEmbedYoutube";
import UGBVideoPopup from "./UGB/VideoPopup";
import UGBImageBox from "./UGB/ImageBox";
import UGBDesignLibrary from "./UGB/DesignLibrary";
import UAGBAdvancedHeading from "./UAGB/AdvancedHeading";
import UAGBFaq from "./UAGB/Faq";
import FaqBlock from "./Yoast/FaqBlock";
import HowToBlock from "./Yoast/HowToBlock";
import DefaultBlockFactory from "./Default";

class BlockFactoryBuilder {
  constructor() {
    const factories = [
      new CoreSpacerFactory(),
      new CoreColumnsFactory(this),
      new CoreColumnFactory(this),
      new CoreGroup(this),
      new CoreHeadingFactory(),
      new CoreTableFactory(),
      new CoreParagraphFactory(),
      new CoreShortCodeFactory(),
      new CoreImageFactory(),
      new CoreEmbedYoutube(),
      new CoreListFactory(),
      new CoreHtmlFactory(),
      new CoreQuoteFactory(),
      new CoreEmbedFactory(),
      new UGBVideoPopup(),
      new UGBImageBox(),
      new UGBDesignLibrary(),
      new UAGBAdvancedHeading(),
      new UAGBFaq(),
      new FaqBlock(),
      new HowToBlock(),
    ];
    this.defaultFactory = new DefaultBlockFactory();
    this.factoriesMap = {};
    factories.forEach((factory) => {
      if (Array.isArray(factory.type))
        for (const type of factory.type)
          this.factoriesMap[type] = factory;
      else
        this.factoriesMap[factory.type] = factory;
    });
  }

  factory = (type) => type && (this.factoriesMap[type] || this.defaultFactory);

  create({ context, block }) {
    const { name } = block;
    const factory = this.factory(name);
    return factory.create({ context, block });
  }
}

export default BlockFactoryBuilder;
